export default __webpack_public_path__ + "static/media/DownloadReport.0810d75c.png";